import { withInstall } from '../../../utils/with-install'
import Scale from './Scale.vue'

export const ElAmapControlScale = withInstall(Scale)
export default ElAmapControlScale
